var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-container"},[_c('vue-c3',{ref:"bar-chart",staticClass:"bar-chart-canvas",class:`${_vm.columns?.length * _vm.BAR_WIDTH < _vm.height ? 'overflowHidden' : ''}`,attrs:{"id":"horizontalChart","handler":_vm.handler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }